import type { RejectionFileRole } from './types';

// The reject endpoint attaches this role as the invoice PDF and copies the raw
// PDF into it when the invoice has no processed one.
export const REJECTION_INVOICE_PDF_ROLE =
  'processed_pdf' satisfies RejectionFileRole;
